'use client'

import React from "react";
import {cn} from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";
import SubCount from "@/components/global/youtube/SubCount";
import VideoCount from "@/components/global/youtube/VideoCount";

import bannerBg from "@/public/global/youtube-banner-bg.svg";
import youtube from "@/public/icons/youtube-banner.png";

export default function YouTubeBanner({
  className = '',
  language,
}: {
  className?: string;
  language: "en" | "de";
}){
  return (
    <div className={cn(
      "inline-flex overflow-clip relative w-[min(86.375rem,100%)] bg-[#112628] p-[2rem]",
      className
    )}>
      <Image
        className="absolute top-0 left-0 !w-full !h-full object-cover object-left pointer-events-none opacity-30"
        src={bannerBg}
        alt=""
      />

      <Link
        href="https://www.youtube.com/@Bitbulldaily?sub_confirmation=1"
        target="_blank"
        rel="noopener noreferrer"
        className="w-full flex items-center gap-[1.5rem] sm:gap-[2rem] relative group"
      >
        <Image
          className="flex-shrink-0 !w-[6rem] sm:!w-[7.75rem] drop-shadow-[0_0_24px_rgba(255,151,151,0.65)]"
          src={youtube}
          quality={100}
          alt=""
        />

        <div className="flex flex-col items-start grow">
          <p className="mb-[1rem] font-medium text-white leading-none text-[2.25rem]">Bitbull</p>

          <div className="flex items-center gap-[1rem] text-[1.625rem] lg:text-[2rem] mb-[.75rem]">
            <p className="hidden sm:block mb-0 leading-none text-white/70">@Bitbulldaily</p>
            <div className="hidden sm:block w-[.75rem] h-[.75rem] rounded-full flex-shrink-0 bg-white/20"/>
            <SubCount
              handle="@Bitbulldaily"
              language={language}
            />
            <div className="w-[.75rem] h-[.75rem] rounded-full flex-shrink-0 bg-white/20"/>
            <VideoCount
              handle="@Bitbulldaily"
            />
          </div>

          <p className="mb-0 leading-none flex gap-[.5rem] items-end">
            <span className="text-[1.625rem] lg:text-[2rem] text-white/70">{language === "en" ? "Welcome to Bitbull!..." : "Willkommen bei Bitbull!..."}</span>
            <span className="text-[1.5rem] lg:text-[1.75rem] text-white font-medium">Show more</span>
          </p>
        </div>

        <div className="flex-shrink-0 hidden sm:flex items-center justify-center bg-white group-hover:bg-white/80 transition-colors rounded-full w-[15.5rem] h-[5rem]">
          <p className="mb-0 text-black font-medium leading-none text-[2rem]">Subscribe</p>
        </div>
      </Link>
    </div>
  );
}